module.exports = __webpack_public_path__ + "img/jianjietopmin.0767fa9b.jpg";